import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import 'dayjs/locale/az';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import { Box, Flex, IconButton, mode, Popover, PopoverTrigger, useColorMode } from '@abb/uikit';
import { Bell02 } from '@abb/uikit/icons/solid/alerts';
import { useGetCampaignList, useGetNotificationList } from 'hooks';
import React, { useCallback, useState } from 'react';
import { CampaignDetailModal } from './CampaignPanel/CampaignDetailModal';
import { AdvanceNotificationModal } from './NotificationPanel/AdvanceNotificationModal';
import { NotificationDetailModal } from './NotificationPanel/NotificationDetailModal';
import { NotificatonCampaignTabs } from './NotificatonCampaignTabs';
export const Notification = ()=>{
    const { data: notificationList, mutate, isValidating } = useGetNotificationList();
    const { data: campaignList, mutate: campaignsMutate } = useGetCampaignList();
    const { colorMode } = useColorMode();
    const [detailModal, setDetailModal] = useState({
        isOpen: false,
        event: null,
        type: null,
        id: null
    });
    const [isOpenAdvanceNotificationModal, setIsOpenAdvanceNotificationModal] = useState(false);
    const notifList = React.useMemo(()=>{
        if (!notificationList) return [];
        return notificationList.content.flatMap((param)=>{
            let { notifications, date } = param;
            return notifications.map((notification)=>({
                    ...notification,
                    date
                }));
        });
    }, [
        notificationList
    ]);
    const handleFetch = useCallback(()=>{
        mutate();
    }, [
        notifList
    ]);
    const hasUnreadNotification = React.useMemo(()=>{
        const unReadCampaign = campaignList === null || campaignList === void 0 ? void 0 : campaignList.some((item)=>!item.read);
        return notifList.some((param)=>{
            let { read } = param;
            return !read;
        }) || unReadCampaign;
    }, [
        notifList,
        campaignList
    ]);
    const initialFocusRef = React.useRef();
    React.useEffect(()=>{
        if (!!notifList) {
            var _notificationToShow_, _notificationToShow_1;
            const advanceNotification = notifList === null || notifList === void 0 ? void 0 : notifList.filter((item)=>(item === null || item === void 0 ? void 0 : item.event) === 'AVANS');
            const isOpen = (advanceNotification === null || advanceNotification === void 0 ? void 0 : advanceNotification.length) > 0 && (advanceNotification === null || advanceNotification === void 0 ? void 0 : advanceNotification.some((notf)=>!(notf === null || notf === void 0 ? void 0 : notf.read)));
            const notificationToShow = advanceNotification === null || advanceNotification === void 0 ? void 0 : advanceNotification.filter((notf)=>!(notf === null || notf === void 0 ? void 0 : notf.read));
            setIsOpenAdvanceNotificationModal(isOpen);
            isOpen && setDetailModal({
                isOpen,
                event: notificationToShow === null || notificationToShow === void 0 ? void 0 : (_notificationToShow_ = notificationToShow[0]) === null || _notificationToShow_ === void 0 ? void 0 : _notificationToShow_.event,
                type: 'notification',
                id: notificationToShow === null || notificationToShow === void 0 ? void 0 : (_notificationToShow_1 = notificationToShow[0]) === null || _notificationToShow_1 === void 0 ? void 0 : _notificationToShow_1.id
            });
        }
    }, [
        notificationList,
        notifList
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Popover, {
                initialFocusRef: initialFocusRef,
                placement: "bottom",
                closeOnBlur: !detailModal.isOpen,
                children: [
                    /*#__PURE__*/ _jsx(PopoverTrigger, {
                        children: /*#__PURE__*/ _jsx(Flex, {
                            alignItems: "center",
                            children: /*#__PURE__*/ _jsx(IconButton, {
                                "aria-label": "notifcation",
                                onClick: handleFetch,
                                _hover: {
                                    background: 'transparent'
                                },
                                bgColor: "transparent",
                                cursor: "pointer",
                                h: "fit-content",
                                icon: /*#__PURE__*/ _jsxs(Box, {
                                    position: "relative",
                                    children: [
                                        hasUnreadNotification && /*#__PURE__*/ _jsx(Box, {
                                            right: "0",
                                            w: "6px",
                                            h: "6px",
                                            position: "absolute",
                                            borderRadius: "99px",
                                            bg: "red"
                                        }),
                                        /*#__PURE__*/ _jsx(Bell02, {
                                            w: "20px",
                                            h: "20px",
                                            fill: mode('black', 'white')({
                                                colorMode
                                            })
                                        })
                                    ]
                                }),
                                isRound: true
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(NotificatonCampaignTabs, {
                        campaignList: campaignList,
                        campaignsMutate: campaignsMutate,
                        notificationList: notifList,
                        onDetailModalOpen: (param)=>{
                            let { event, type, id } = param;
                            event === 'AVANS' ? setIsOpenAdvanceNotificationModal(true) : setIsOpenAdvanceNotificationModal(false);
                            setDetailModal({
                                isOpen: true,
                                event,
                                type,
                                id
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CampaignDetailModal, {
                isOpen: detailModal.isOpen && detailModal.type === 'campaign' && !isOpenAdvanceNotificationModal,
                onClose: ()=>setDetailModal({
                        isOpen: false,
                        event: null,
                        type: null,
                        id: null
                    }),
                campaign: campaignList === null || campaignList === void 0 ? void 0 : campaignList.find((c)=>c.id === detailModal.id)
            }),
            /*#__PURE__*/ _jsx(NotificationDetailModal, {
                isOpen: detailModal.isOpen && detailModal.type === 'notification' && !isOpenAdvanceNotificationModal,
                onClose: ()=>setDetailModal({
                        isOpen: false,
                        event: null,
                        type: null,
                        id: null
                    }),
                notification: notifList.find((n)=>n.id === detailModal.id)
            }),
            !isValidating && isOpenAdvanceNotificationModal && /*#__PURE__*/ _jsx(AdvanceNotificationModal, {
                isOpen: detailModal.isOpen && detailModal.type === 'notification' || isOpenAdvanceNotificationModal,
                onClose: ()=>{
                    mutate();
                    setIsOpenAdvanceNotificationModal(false);
                    setDetailModal({
                        isOpen: false,
                        event: null,
                        type: null,
                        id: null
                    });
                },
                notification: notifList.find((n)=>n.id === detailModal.id)
            })
        ]
    });
};
